import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initializeGTM, trackPageView } from "../../../utils/gtm";

export const usePageTracking = (): void => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== "undefined" && !window.dataLayer && process.env.NODE_ENV === "production") {
      initializeGTM();
    }

    trackPageView(location.pathname + location.search + location.hash);
  }, [location]);
};
